import React, { useEffect, useRef } from 'react';
import { CategoryOption } from './Categories';
import styled from 'styled-components';

const Container = styled.button`
  height: 40px;
  border-radius: 40px;
  margin-right: 15px;
  padding-inline: 24px;
  justify-content: center;
  align-items: center;
  border: 2px solid #0a0a0a66;
  background-color: white;
  font-size: 14px;

  &:focus {
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid #5e9ed6;
    text-decoration: none;
  }
`;

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected?: boolean;
  option: CategoryOption;
  setSelectedOption: ((option: CategoryOption) => void) | undefined;
  getName: ((option?: CategoryOption) => void) | undefined;
}

const CatetoryItem: React.FC<Props> = ({
  isSelected,
  setSelectedOption,
  option,
  getName,
  ...rest
}) => {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (isSelected) {
      ref.current?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      });
    }
  }, [isSelected]);
  return (
    <Container ref={ref} onClick={() => setSelectedOption?.(option)} {...rest}>
      {getName?.(option) ?? option?.name}
    </Container>
  );
};

export default CatetoryItem;
